import { useState } from "react";
import { RenderWhen } from "../../../../../components";

import MethodologyPopup from "../../../../../components/MethodologyPopup";

import RiskScore from "./RiskScore";

type Props = {
  classification?: string;
  factor?: number;
};

const RiskScoreCard = ({ classification = "unknown", factor = 5 }: Props) => {
  const [show, setShow] = useState(false);

  const handleIconClick = () => {
    setShow(true);
  };

  return (
    <>
      <RiskScore
        classification={classification}
        factor={factor}
        onClick={handleIconClick}
      />
      <RenderWhen condition={show}>
        <MethodologyPopup open={show} onClose={setShow} />
      </RenderWhen>
    </>
  );
};

export default RiskScoreCard;
